import "./styles.css";

const Loading = () => {
  return (
    <div className="loading-container" data-testid="loading-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loading;
